import {light} from './light.js'
import {dark} from './dark.js'

export const theme =  {
    themes: {
        light,
        dark
    }
}